var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card__content" }, [
      _c(
        "div",
        { staticClass: "table-responsive" },
        [
          _c("vue-good-table", {
            attrs: {
              columns: _vm.columns,
              "pagination-options": {
                enabled: true,
                perPage: 10,
                perPageDropdown: _vm.dropDown,
                nextLabel: "siguiente",
                prevLabel: "anterior",
                rowsPerPageLabel: "Registros por página",
                ofLabel: "de",
                allLabel: "Todo",
                dropdownAllowAll: true
              },
              rows: _vm.registros,
              "search-options": {
                enabled: true,
                placeholder: "Buscar..."
              },
              styleClass: "vgt-table vgt-table--sticky"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h3", [_vm._v("Auditoría")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05f773b3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f773b3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/AuditoriaPrestamo.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-05f773b3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/AuditoriaPrestamo.vue
// module chunks = 0